// Η καρτέλα «Κάτοψη» του ταμείου: ο editor κάτοψης, μέσα στο ταμείο (floorEditor/).
// Ίδιες επιλογές και ίδιο μοντέλο με τον editor της Sala (κοινός κώδικας στο
// utils/salaFloor), αποθήκευση στο κοινό /api/floor — ό,τι αλλάξει εδώ ισχύει και στη Sala.

import FloorEditorScreen from './floorEditor/FloorEditor';

export default function FloorPlanEditor() {
  return <FloorEditorScreen />;
}
